import { createContext, useContext, Context } from "react";
import { WebSocketService } from "../services/webSocketService";

export const WebSocketServiceContext: Context<WebSocketService> = createContext(null);
export const useWebSocketService: () => WebSocketService = () => useContext(WebSocketServiceContext);
export const WebSocketServiceProvider = ({
    webSocketService,
    children
}: { webSocketService: WebSocketService, children: any }) => (
    <WebSocketServiceContext.Provider value={webSocketService}>
        {children}
    </WebSocketServiceContext.Provider>
);